import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../helpers/reducerRegistry'
import { getTotalCompanyBySettings } from './thunk'

const initialState = {
  organizationIds: [],
  totalCompanyBySetting: 0,
  isLoading: true,
}

const slice = createSlice({
  name: 'common/filterCompany/totalCompanies',
  initialState,
  reducers: {
    resetStoreTotalCompanies: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getTotalCompanyBySettings.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(getTotalCompanyBySettings.fulfilled, (state, action) => {
      state.totalCompanyBySetting = (action.payload || []).length
      state.organizationIds = action.payload
      state.isLoading = false
    })
    builder.addCase(getTotalCompanyBySettings.rejected, (state, action) => {
      state.isLoading = action.payload.loading
    })
  },
})

export const selectLoadingTotalCompanies = (state) =>
  state[slice.name].isLoading

export const getTotalCompanyBySetting = (state) =>
  state[slice.name].totalCompanyBySetting

export const selectOrganizationIds = (state) =>
  state[slice.name].organizationIds

export const { resetStoreTotalCompanies } = slice.actions

register(slice.name, slice.reducer)
